import Logger from '../../../services/Logger';
import Toast from '../../../components/Toast';
import l18n from '../../../shared/strings';
import saveTeamSetting from './saveTeamSetting';

const saveDescriptionLocale = (value) => async (dispatch, getState) => {
  const prevDescribing = getState().user.team?.settings?.describingLocale || 'en';
  const describingSaved = await dispatch(saveTeamSetting('describingLocale', value));
  if (!describingSaved) return;

  const embeddingSaved = await dispatch(saveTeamSetting('embeddingDescribingLocale', value));
  if (!embeddingSaved) {
    const reverted = await dispatch(saveTeamSetting('describingLocale', prevDescribing, { silent: true }));
    if (!reverted) {
      Logger.error(new Error('Could not revert describingLocale after embeddingDescribingLocale save failed'), {}, [
        'DescriptionLocaleSyncFailed',
        { attemptedLocale: value, describingLocale: prevDescribing },
      ]);
      Toast(l18n.TEAMMATES.errorUpdateDescribingLocaleSync, { type: 'error' });
    }
  }
};

export default saveDescriptionLocale;
